import React from "react";
import { useTranslation } from "react-i18next";


const SharedAmenities: React.FunctionComponent<{ property: any, onchangeSharedAmenities: any }> = (props) => {

    const sharedAmenitiesList = [
        "Conference Room", "Dining in Building", "Shared Pool",
        "Covered Parking", "Pantry", "Available Networked", "Lobby in Building",
        "Shared Gym", "Vastu - compliant", "Mezzanine"
    ];
    const { t } = useTranslation();

    const handleChangeSharedAmenities = (value: any) => {
        props.onchangeSharedAmenities(value)
    }

    return (
        <>
            <div className="card-form mb-4">
                <div className="amenities-grid">
                    {sharedAmenitiesList.map((amenity, index) => (
                        <div key={index} className="form-check mb-2">
                            <input
                                id={`check-${index}-${amenity}`}
                                type="checkbox"
                                className="form-check-input"
                                name={`check-${index}-${amenity}`}
                                onChange={() => handleChangeSharedAmenities(amenity)}
                                checked={props.property.sharedAmenities?.includes(amenity) || false}
                            />
                            <label className="form-check-label">{t(`amenitiesList.${amenity}`)}</label>
                        </div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default SharedAmenities;